export default __webpack_public_path__ + "static/media/Cera_Scaglie_Fumo_120x120_small.5238c18d.jpg";